import { render } from "./SocialIcons.vue?vue&type=template&id=7bfef8b6"
import script from "./SocialIcons.vue?vue&type=script&lang=ts"
export * from "./SocialIcons.vue?vue&type=script&lang=ts"
script.render = render

export default script